import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom'; 
import { auth, db } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

// Components
import Header from './components/Header';
import MarketplaceScreen from './screens/MarketplaceScreen';
import ArtistWorksScreen from './screens/ArtistWorksScreen';
import ArtworkDetailsScreen from './screens/ArtworkDetailsScreen';
import SignInScreen from './screens/SignInScreen';
import SignUpScreen from './screens/SignUpScreen';
import UserProfileScreen from './screens/UserProfileScreen';
import PurchaseSuccessScreen from './screens/PurchaseSuccessScreen';
import PurchasesScreen from './screens/PurchasesScreen';
import UploadArtScreen from './screens/UploadArtScreen';
import ListingPreviewScreen from './screens/ListingPreviewScreen';
import ExhibitionScreen from './screens/ExhibitionScreen';

function App() {
  const [user, setUser] = useState(null);
  const [isArtist, setIsArtist] = useState(false);
  const [initializing, setInitializing] = useState(true);
  const [isOnProfileScreen, setIsOnProfileScreen] = useState(false);

  const updateUserData = (updates) => {
    setUser(prev => ({
      ...prev,
      ...updates
    }));
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const userData = { id: userDoc.id, ...userDoc.data() };
          setIsArtist(userData.isArtist || false);
          setUser(userData);
        } else {
          setUser(null);
          setIsArtist(false);
        }
      } else {
        setUser(null);
        setIsArtist(false);
      }
      if (initializing) setInitializing(false);
    });

    return () => unsubscribe();
  }, []);

  if (initializing) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="App">
      <Header user={user} isArtist={isArtist} />
      <main>
        <Routes>
          <Route path="/" element={<MarketplaceScreen />} />
          <Route path="/artist/:artistId" element={<ArtistWorksScreen />} />
          <Route path="/artwork/:artworkId" element={<ArtworkDetailsScreen />} />
          <Route path="/exhibition/:exhibitionId" element={<ExhibitionScreen />} />
          <Route path="/signin" element={<SignInScreen />} />
          <Route path="/signup" element={<SignUpScreen />} />
          <Route path="/profile" element={<UserProfileScreen user={user} onUpdateUser={updateUserData} />} />
          <Route path="/profile/:userId" element={<UserProfileScreen />} />
          <Route path="/profile/purchases" element={<PurchasesScreen user={user} />} />
          <Route path="/purchase-success" element={<PurchaseSuccessScreen />} />
          <Route path="/upload" element={<UploadArtScreen />} />
          <Route path="/listing-preview" element={<ListingPreviewScreen />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
